// extracted by mini-css-extract-plugin
module.exports = {"conatiner":"Loading_conatiner__1M6Pr","loading_text":"Loading_loading_text__3l2gC","SuccessContainer":"Loading_SuccessContainer__15Go2"};